
import { Grid, Typography, TextField } from "@mui/material";
import { useState } from "react";
import MDDatePicker from "components/MDDatePicker";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

function AddDateView({ onSave }) {
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);

  const handleSave = () => {
    if (title && startDate && endDate) {
      onSave({ title, startDate, endDate });
    } else {
      console.log(startDate[0])
      alert(t("trajectories.wizard.addDateView.warningMessage"));
    }
  };

  return (
    <Grid container spacing={3} p={3}>
      {/* Title */}
      <Grid item xs={12}>
        <Typography variant="h4" textAlign="center">
          {t("trajectories.wizard.addDateView.title")}
        </Typography>
      </Grid>

      {/* Title Input */}
      <Grid item xs={12}>
        <TextField
          label={t("trajectories.wizard.addDateView.labels.title")}
          variant="outlined"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          fullWidth
        />
      </Grid>

      {/* Date Pickers */}
      <Grid item xs={12} sm={6}>
        <MDDatePicker
          label={t("trajectories.wizard.addDateView.labels.start")}
          value={startDate}
          onChange={(newValue) => setStartDate(newValue)}
          options={{ maxDate: new Date().fp_incr(-1) }}
          renderInput={(params) => <TextField placeholder="Start Date" {...params} fullWidth />}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDDatePicker
          label={t("trajectories.wizard.addDateView.labels.end")}
          value={endDate}
          onChange={(newValue) => setEndDate(newValue)}
          options={{ maxDate: new Date().fp_incr(-1),  minDate: startDate[0]  }}
          
          renderInput={(params) => <TextField placeholder="End Date" {...params} fullWidth />}
        />
      </Grid>

      {/* Buttons */}
      <Grid item xs={12} container justifyContent="space-between">
        <Grid item>
          <MDButton
            variant="outlined"
            color="error"
            size="medium"
            onClick={() => onSave(null)}
          >
            {t("common.buttons.cancel")}
          </MDButton>
        </Grid>
        <Grid item>
          <MDButton
            variant="contained"
            color="info"
            size="medium"
            onClick={handleSave}
          >
            {t("trajectories.wizard.addDateView.buttonSave")}
          </MDButton>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AddDateView;
